<template>
  <b-card class="statistics-component">
    <b-row align-h="between">
      <b-col cols="auto">
        <h1>Stadistics</h1>
      </b-col>
      <b-col cols="auto">
        <b-dropdown right text="Filters" variant="primary" boundary="window">
          <b-dropdown-form>
            <b-form-checkbox-group v-model="selected" v-for="({ title }, key) in stadistics" :key="key">
              <b-form-checkbox :value="title">{{ title }}</b-form-checkbox>
            </b-form-checkbox-group>
          </b-dropdown-form>
        </b-dropdown>
      </b-col>
    </b-row>
    <div class="statistics-chart-container">
      <vue-apex-charts v-if="series.length" :options="chartOptions" :series="series" type="bar" />
    </div>
    <mixn ref="mixin" />
  </b-card>
</template>

<script>
import { BDropdownForm, BCard, BImg, BAvatar, BCardText, BDropdown, BFormCheckbox } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import mixn from "@/components/mixn.vue";
import { isMobileDevice, getCurrentConfig } from "../config/mobile.config";

export default {
  components: {
    mixn,
    BDropdownForm,
    BCard,
    BAvatar,
    BImg,
    BCardText,
    VueApexCharts,
    BDropdown,
    BFormCheckbox
  },
  props: {
    stadistics: {
      type: Array,
      default: () => [],
      required: true
    },
  },
  data() {
    return {
      series: [],
      stadisticProps: [],
      selected: [],
      mobileConfig: null,
      chartOptions: {
        chart: {
          height: 300,
          type: 'bar',
        },
        colors: [],
        plotOptions: {
          bar: {
            borderRadius: 10,
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        tooltip: {
          y: {
            title: {
              formatter: (val, opt) => {
                const stadisticProps = this.stadisticProps
                const stadistic = stadisticProps.find((stadistic) => stadistic.title == opt.w.globals.labels[opt.dataPointIndex])?.description
                return stadistic + ':'
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#333'],
            fontSize: '16px',
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: {
                height: 350
              },
              legend: {
                fontSize: '12px',
                position: 'bottom'
              },
              dataLabels: {
                fontSize: '12px'
              }
            }
          }
        ]
      }
    }
  },
  watch: {
    stadistics() {
      this.filterData()
    },
    selected() {
      this.filterData(true)
    }
  },
  methods: {
    filterData(hasBeenSelected = false) {
      this.stadisticProps = this.stadistics
      this.series = [{
        data: this.stadistics
          .filter(({ title }) => !hasBeenSelected || this.selected.length === 0 || this.selected.includes(title))
          .map(({ value, title }) => ({ x: title, y: value }))
      }];
    },
    
    updateChartOptions() {
      if (this.mobileConfig) {
        this.chartOptions.chart.height = this.mobileConfig.charts.height;
        this.chartOptions.dataLabels.style.fontSize = this.mobileConfig.charts.fontSize.labels;
        this.chartOptions.legend.fontSize = this.mobileConfig.charts.fontSize.legend;
        this.chartOptions.tooltip.style = {
          fontSize: this.mobileConfig.charts.fontSize.tooltip
        };
      }
    }
  },
  mounted() {
    // Obtener configuración móvil
    this.mobileConfig = getCurrentConfig();
    this.updateChartOptions();
    
    // Escuchar cambios de tamaño de ventana
    window.addEventListener('resize', this.handleResize);
    
    this.filterData();
  },
  beforeDestroy() {
    // Limpiar event listener
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // Actualizar configuración cuando cambie el tamaño de la ventana
      this.mobileConfig = getCurrentConfig();
      this.updateChartOptions();
    },
    
    filterData(hasBeenSelected = false) {
      this.stadisticProps = this.stadistics
      this.series = [{
        data: this.stadistics
          .filter(({ title }) => !hasBeenSelected || this.selected.length === 0 || this.selected.includes(title))
          .map(({ value, title }) => ({ x: title, y: value }))
      }];
    },
    
    updateChartOptions() {
      if (this.mobileConfig) {
        this.chartOptions.chart.height = this.mobileConfig.charts.height;
        this.chartOptions.dataLabels.style.fontSize = this.mobileConfig.charts.fontSize.labels;
        this.chartOptions.legend.fontSize = this.mobileConfig.charts.fontSize.legend;
        this.chartOptions.tooltip.style = {
          fontSize: this.mobileConfig.charts.fontSize.tooltip
        };
      }
    }
  }
};
</script>

<style scoped>
.statistics-chart-container {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

@media (max-width: 767px) {
  .statistics-component {
    padding: 1rem;
  }
  
  .statistics-component h1 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  
  .b-dropdown {
    width: 100%;
  }
  
  .b-dropdown .btn {
    width: 100%;
    text-align: left;
  }
}
</style>